module.exports = __webpack_public_path__ + "static/img/return.853526b5.svg";